import styled from '@emotion/styled';
import { alpha, Button } from '@mui/material';

export const ModalCard = styled.div(({ theme }) => ({
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.background.paper,
  width: '90%',
  maxWidth: 560,
  borderRadius: 16,
  overflow: 'hidden',
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column' as const,
  outline: 'none',
  boxShadow: `0 4px 24px -4px ${alpha(theme.palette.common.black, 0.12)}, 0 16px 56px -8px ${alpha(theme.palette.common.black, 0.14)}`,
  [theme.breakpoints.up('sm')]: {
    width: 560,
  },
}));

export const IconContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: 32,
  paddingBottom: 4,
});

export const IconCircle = styled.div<{ variantColor: string }>(({ variantColor }) => ({
  width: 64,
  height: 64,
  borderRadius: '50%',
  background: `linear-gradient(135deg, ${alpha(variantColor, 0.12)}, ${alpha(variantColor, 0.06)})`,
  border: `1.5px solid ${alpha(variantColor, 0.15)}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ContentContainer = styled.div({
  paddingLeft: 28,
  paddingRight: 28,
  paddingBottom: 28,
});

export const TextContainer = styled.div({
  flex: '1 1 auto',
  overflowY: 'auto' as const,
  marginBottom: 28,
  minHeight: 0,
});

export const OkButton = styled(Button)({
  paddingTop: 10,
  paddingBottom: 10,
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: 10,
  fontSize: '0.925rem',
  letterSpacing: '0.01em',
  transition: 'filter 0.15s ease',
  '&:hover': {
    filter: 'brightness(0.92)',
  },
});
